// extracted by mini-css-extract-plugin
export default {"title":"AddPost_title__5HOS4","image":"AddPost_image__D7bNn","editor":"AddPost_editor__F84jL","buttons":"AddPost_buttons__u1bJ1"};